<template>
  <div class="container table-responsive">
    <br />
    <br />
    <b-loading :is-full-page="isFullPage" v-model="isLoading" :can-cancel="true"></b-loading>
    <b-notification
      type="is-danger"
      auto-close
      v-model="isActive"
      aria-close-label="Close notification"
    >LOGIN TO CONTINUE</b-notification>
    <b-notification
      type="is-danger"
      v-model="isEmpty"
      auto-close
      aria-close-label="Close notification"
    >YOUR CART IS EMPTY</b-notification>
    <b-notification
      type="is-success"
      v-model="isChecked"
      aria-close-label="Close notification"
    >CHECK OUT SUCCESSFUL</b-notification>
    <div class="cartfunctions">
      <strong class="total">Total Cart Cost: ₦{{ cartValue }}.00</strong>
      <br />
      <b-button
        type="is-success"
        class="checkout"
        @click="saveShoppingCartLocal"
        label="SAVE SHOPPING CART"
      ></b-button>
    </div>
    <transition-group name="list-shopping-cart" tag="tbody">
      <app-cart-item v-for="cartItem in cartItemList" :cartItem="cartItem" :key="cartItem.name"></app-cart-item>
    </transition-group>
    <br />
    <b-notification
      type="is-danger"
      auto-close
      v-if="cartItemList.length > 0"
      v-model="isActive"
      aria-close-label="Close notification"
    >PLEASE LOGIN TO CONTINUE</b-notification>
    <b-notification
      type="is-danger"
      v-model="isEmpty"
      auto-close
      v-if="cartItemList.length > 0"
      aria-close-label="Close notification"
    >YOUR CART IS EMPTY</b-notification>
    <b-notification
      type="is-success"
      v-model="isChecked"
      v-if="cartItemList.length > 0"
      aria-close-label="Close notification"
    >CHECK OUT SUCCESSFUL</b-notification>

    <v-btn @click="checkoutproceed">proceed to checkout</v-btn>
    <br />
    <br />
    <br />
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        class="checkoutpage"
        transition="dialog-bottom-transition"
        fullscreen
        hide-overlay
      >
        <v-card>
          <br />
          <p>CHECKOUT</p>
          <hr />
          <div v-for="checkoutItem in cartItemList" class="checking" :key="checkoutItem.name">
            <v-card class="checkoutdialog">
              <v-img class="checkoutimg" :src="checkoutItem.picture" />
              <div class="checkouthead">
                {{ checkoutItem.name}}
                <br />
                <div class="about">
                  <br />
                  {{checkoutItem.description }}
                  <br />
                  <br />
                  Quantity: {{checkoutItem.quantity}}pcs
                </div>
                <br />
              </div>

              <br />
              <div class="action">
                <!-- Quantity: {{checkoutItem.quantity}}pcs -->
                <br />
                ₦{{checkoutItem.price * checkoutItem.quantity}}.00
                <br />
              </div>
            </v-card>
          </div>
          <br />
          <hr />
          <v-checkbox
            v-model="checkbox3"
            disabled
            label="USE DELIVERY INFORMATION AVAILABLE (IF YOU WOULD LIKE TO USE A DIFFERENT LOCATION PLEASE CHNAGE IT IN YOUR ACCOUNT DETAILS)"
          ></v-checkbox>
          <v-checkbox v-model="checkbox" disabled label="PAY ON DELIVERY"></v-checkbox>
          <v-checkbox v-model="checkbox2" disabled label="PAY USING DEBIT CARD (NOT AVAILABLE) "></v-checkbox>
          <div class="checkoutActions">
            <v-btn @click="dialog = false">back to cart</v-btn>
            <br />
            <v-btn
              class="realcheckout"
              :loading="loading"
              @click="checkout"
            >checkout (₦{{cartValue}}.00)</v-btn>
            <hr />
            <br />
          </div>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CartItem from "./cart/CartItem.vue";
export default {
  data() {
    return {
      isActive: false,
      LGA: "",
      isEmpty: false,
      isChecked: false,
      isLoading: false,
      loading: false,
      isFullPage: true,
      isPhone: false,
      isLGA: false,
      checkbox3: true,
      direction: "bottom",
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      checkbox: true,
      right: true,
      bottom: true,
      left: false,
      isState: false,
      transition: "slide-x-reverse-transition",
      dialog: false,
      checkbox2: false,
      value: "",
      address: "",
      phone: "",
      items: [
        "Abia",
        "Adamawa",
        "Akwa Ibom",
        "Anambra",
        "Bauchi",
        "Bayelsa",
        "Benue",
        "Borno",
        "Cross River",
        "Delta",
        "Ebonyi",
        "Edo",
        "Ekiti",
        "Enugu",
        "FCT - Abuja",
        "Gombe",
        "Imo",
        "Jigawa",
        "Kaduna",
        "Kano",
        "Katsina",
        "Kebbi",
        "Kogi",
        "Kwara",
        "Lagos",
        "Nasarawa",
        "Niger",
        "Ogun",
        "Ondo",
        "Osun",
        "Oyo",
        "Plateau",
        "Rivers",
        "Sokoto",
        "Taraba",
        "Yobe",
        "Zamfara"
      ]
    };
  },
  computed: {
    ...mapGetters([
      "cartItemList",
      "isLoggedIn",
      "products",
      "currentUser",
      "cartValue"
    ]),
    numItems() {
      return this.cartItemList.length;
    }
  },
  components: {
    appCartItem: CartItem
  },
  methods: {
    ...mapActions([
      "saveShoppingCart",
      "addMessage",
      "saveToTransaction",
      "clearCart"
    ]),

    saveShoppingCartLocal() {
      if (this.cartItemList.length > 0) {
        this.saveShoppingCart({
          cartItemList: this.cartItemList,
          uid: this.currentUser.uid
        }).then(alert("saved"));
      } else {
        alert("not saved");
      }
    },
    checkout() {
      if (this.checkbox == true || this.checkbox2 == true) {
        this.isLoading = true;
        setTimeout(() => (this.$buefy.toast.open({
        message: `CHECKOUT SUCCESSFUL`,
        type: "is-success",
        position: "is-top-right"
      })), 2000);
        this.$fb.database
          .collection("order")
          .add({
            cartItemList: this.cartItemList,
            email: this.currentUser.email,
            total: this.cartValue,
            Payondelivery: true,
            address: this.address,
            phone: this.phone,
            LGA: this.LGA,
            state: this.value
          })
          .then(() => {
            this.saveShoppingCart({
              cartItemList: [],
              uid: this.currentUser.uid
            });
            setTimeout(() => this.clearCart(), 1900);
            setTimeout(() => this.$router.push("/"), 4000);
          });
      }
    },
    checkoutproceed() {
      // const cart = {
      //   cartItemList: this.currentUser.uid,
      //   total: this.cartValue,
      //   user: this.currentUser
      // };
      if (this.cartItemList.length < 1) {
        return (this.isEmpty = true);
      } else if (this.isLoggedIn) {
        this.dialog = true;
      } else {
        return (
          (this.isActive = true),
          setTimeout(() => this.$router.push("/mobile-view-auth"), 2000)
        );
      }
    }
  },
  filters: {
    shorterDescription(value) {
      if (value && value.length > 200) {
        return value.substring(0, 80) + "...";
      } else {
        return value;
      }
    },
    fetchData() {
      this.$fb.database
        .collection("accountdata")
        .where("email", "==", this.currentUser.email)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.address = doc.data().address;
            this.phone = doc.data().phone;
            this.value = doc.data().state;
            this.LGA = doc.data().LGA;
          });
        });
    },
    beforeRouteEnter(to, from, next) {
      this.$fb.database
        .collection("accountdata")
        .where("email", "==", this.currentUser.email)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            next(vm => {
              vm.address = doc.data().address;
              vm.phone = doc.data().phone;
              vm.value = doc.data().state;
              vm.LGA = doc.data().LGA;
            });
          });
        });
    }
  }
};
</script>
<style >
.deliverystate {
  width: 100%;
}
.details {
  justify-content: space-between;
  width: 100%;
  margin: auto;
  padding: 2em;
}
.deliveryinput {
  width: 100%;
}
.address {
  text-align: center;
  text-decoration: underline;
}
.checkoutpage {
  width: 90%;
  margin: 2em;
}
.checking {
  padding: 3em;
  padding-bottom: 0;
}
.realcheckout {
  margin-left: 0.5em;
}
.checkoutActions {
  display: flex;
  margin: 0.5em;
}
.checkouthead {
  padding-top: 25px;
  display: block;
}
.about {
  width: 50%;
}
.action {
  margin-left: 30em;
}
.cartfunctions {
  display: flex;
  width: 100%;
}
.checkout {
  margin-left: 5em;
}
#create .v-speed-dial {
  position: absolute;
}
.checkoutdialog {
  display: flex;
  margin-top: 1em;
  padding: 3em;
}
#create .v-btn--floating {
  position: relative;
}
.checkoutimg {
  width: 20%;
}
@media only screen and (max-width: 411px) {
  .checkoutimg {
    width: 100px;
  }
  .checkoutdialog {
    display: flex;
    margin-top: 1em;
  }
  .action {
    margin: 0;
  }
  .about {
    display: none;
  }
}
@media only screen and (min-width: 412px) {
  .checkoutdialog {
    display: flex;
    margin-top: 1em;
  }
  .action {
    margin: 0;
  }
  .about {
    display: flex;
  }
}
</style>
